var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 25,
    viewBox: "0 0 74 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9441 24.384H25.9727L29.7076 1.28979H35.6787L31.9441 24.384Z",
    fill: "#949CB2",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5904 1.85431C52.4126 1.38703 50.5445 0.871094 48.2345 0.871094C42.3375 0.871094 38.1849 4.01568 38.1594 8.51149C38.1105 11.8285 41.1326 13.6708 43.3929 14.7768C45.7032 15.907 46.4885 16.6446 46.4885 17.652C46.465 19.1992 44.6217 19.9123 42.9024 19.9123C40.5184 19.9123 39.2409 19.5446 37.2997 18.6839L36.5134 18.3149L35.6777 23.499C37.0783 24.1371 39.6586 24.7033 42.3375 24.7281C48.6032 24.7281 52.6823 21.6322 52.7307 16.8412C52.7545 14.2122 51.1587 12.1978 47.7183 10.5517C45.6297 9.49502 44.3506 8.78251 44.3506 7.70134C44.3751 6.71845 45.4325 5.71173 47.7901 5.71173C49.7314 5.66242 51.1577 6.12905 52.2382 6.596L52.7783 6.84123L53.5904 1.85431Z",
    fill: "#949CB2",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5259 16.2026C62.0177 14.8758 63.91 9.74098 63.91 9.74098C63.8852 9.79029 64.4008 8.38976 64.6956 7.52998L65.113 9.51992C65.113 9.51992 66.2438 15.0479 66.4893 16.2026C65.5561 16.2026 62.7054 16.2026 61.5259 16.2026ZM68.8969 1.28979H64.278C62.8536 1.28979 61.7715 1.70711 61.1569 3.20593L52.2871 24.3837H58.5528C58.5528 24.3837 59.5843 21.5333 59.806 20.9194C60.4934 20.9194 66.5886 20.9194 67.4729 20.9194C67.6443 21.7302 68.1854 24.3837 68.1854 24.3837H73.7144L68.8969 1.28979Z",
    fill: "#949CB2",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9842 1.28979L15.1362 17.0379L14.4971 13.844C13.416 10.1586 10.0252 6.15459 6.24121 4.16368L11.5978 24.3595H17.9124L27.2985 1.28979H20.9842Z",
    fill: "#949CB2",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70576 1.28979H0.0982882L0 1.75642C7.49443 3.67289 12.4578 8.29245 14.4971 13.8449L12.4085 3.23108C12.0647 1.75609 11.008 1.33845 9.70576 1.28979Z",
    fill: "#949CB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visaLogo.bc5470fe6f229a95dda22898993b68f7.svg";
export { ForwardRef as ReactComponent };